export const ownershipType = [
  {text: 'Собственник', value: 'OWNER'},
  {text: 'Представитель', value: 'REPRESENTATIVE'},
  {text: 'Арендатор', value: 'TENANT'}
]

export const ownershipTypeAsString = function(type) {
  return ownershipType.find(it => it.value === type).text
}
